var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 47,
    viewBox: "0 0 37 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8182 1.54523H1.63636C1.28491 1.54523 1 1.83014 1 2.1816V45.1363C1 45.4877 1.28491 45.7727 1.63636 45.7727H35.3636C35.7151 45.7727 36 45.4877 36 45.1363V14.9089M36 14.9089L22.8614 1.77022C22.6609 1.56978 22.3182 1.71174 22.3182 1.99521V14.5907C22.3182 14.7665 22.4606 14.9089 22.6364 14.9089H36Z",
    stroke: "#908C95",
    strokeWidth: 1.90909
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1814 25.728V29.5462M25.8178 25.728V29.5462M13.4087 39.0917H23.5905",
    stroke: "#908C95",
    strokeWidth: 1.90909,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodata);
export default __webpack_public_path__ + "static/media/nodata.b227bb0968ef92786f62e6e10a61856f.svg";
export { ForwardRef as ReactComponent };